//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from 'axios';

export default {
	data() {
		return {
			menu: null,
			show: false,
			showSearch: false,
			searchTerm: '',
			buttonObject: null,
		};
	},

	props: {
		phone: {
			type: String,
			default: '1300 892 383',
		},
		email: {
			type: String,
			default: 'mailto:email@email.com',
		},
		emailLogo: {
			type: String,
			default: '#',
		},
		linkedIn: {
			type: String,
			default: '#',
		},
		linkedInLogo: {
			type: String,
			default: '#',
		},
		homeUrl: {
			type: String,
			default: '#',
		},
		siteName: {
			type: String,
			default: 'Site Name',
		},
		logo: {
			type: String,
			default: '',
		},
		ham: {
			type: String,
			default: '',
		},
		hamClose: {
			type: String,
			default: '',
		},
		searchIcon: {
			type: String,
			default: '',
		},
		searchIconClose: {
			type: String,
			default: '',
		},
		facebookLogo: {},
		facebookUrl: {},
		instaLogo: {},
		instaUrl: {},
		raaLogo: {},
		raaUrl: {},
		buttonLabel: {},
		buttonUrl: {},
	},

	computed: {
		isDisabled() {
			// you can  check your form is filled or not here.
			if (this.searchTerm.length > 0) {
				return true;
			} else {
				return false;
			}
		},
	},

	watch: {},

	methods: {
		localUrlSwap(value) {
			if (window.location.host === 'localhost:3000') {
				return value.replace('bpb-auto.test', 'localhost:3000');
			} else {
				return value;
			}
		},
	},

	components: {},

	created() {},
	mounted() {
		axios
			.get('/wp-json/wp/v2/menu')
			.then((response) => (this.menu = response.data));
		this.buttonObject = JSON.parse(this.buttonUrl);
	},
};



// WEBPACK FOOTER //
// ./scripts/vue/SiteHeader.vue